export async function toBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve({name: file.name, data: reader.result});
        reader.onerror = reject;
    });
}

export async function toBlob(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => resolve({name: file.name, type: file.type, data: reader.result});
        reader.onerror = reject;
    });
}
